





















import { defineComponent, computed } from '@vue/composition-api';

import {
  getDistricts,
} from '@/api';

const CommonDistrictSelector = defineComponent({
  props: {
    level: {},
    label: {
      type: String,
      default() { return 'อำเภอ'; },
    },
    value: {
      type: [Object],
      default() { return null; },
    },
    showLabel: { default: false },
    rules: { default: '' },
    provinceId: { default: -1 },
    showAsEnglish: { default: false },
  },
  setup(props: any) {
    const getDistrictsResult = (data: any) => data;

    const _value = computed(() => props.value);

    return {
      getDistricts,
      getDistrictsResult,
      _value,
    };
  },
});

export default CommonDistrictSelector;
